module.exports = __webpack_public_path__ + "static/media/splash.669e60ec.png";